import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPersonCircleLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M8.22 6.125C9.121 4.997 10.445 4.5 12 4.5s2.878.497 3.78 1.625C16.65 7.211 17 8.726 17 10.5s-.35 3.289-1.22 4.375C14.879 16.003 13.555 16.5 12 16.5s-2.878-.497-3.78-1.625C7.35 13.789 7 12.274 7 10.5s.35-3.289 1.22-4.375m1.56 1.25C9.317 7.955 9 8.94 9 10.5s.316 2.545.78 3.125c.431.538 1.107.875 2.22.875s1.789-.337 2.22-.875c.464-.58.78-1.565.78-3.125s-.316-2.545-.78-3.125C13.788 6.837 13.112 6.5 12 6.5s-1.789.337-2.22.875'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M8.52 17.146c.762.465 1.89.747 3.48.747 1.588 0 2.717-.282 3.478-.747a1 1 0 0 1 1.041 1.708c-1.19.726-2.728 1.039-4.52 1.039s-3.33-.313-4.52-1.04a1 1 0 0 1 1.042-1.707'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.832 20.168c2 2 4.844 2.832 8.168 2.832s6.168-.832 8.168-2.832S23 15.324 23 12s-.832-6.168-2.832-8.168S15.324 1 12 1s-6.168.832-8.168 2.832S1 8.676 1 12s.832 6.168 2.832 8.168M12 21c-3.017 0-5.262-.754-6.754-2.246S3 15.017 3 12s.754-5.262 2.246-6.754S8.983 3 12 3s5.262.754 6.754 2.246S21 8.983 21 12s-.754 5.262-2.246 6.754S15.017 21 12 21'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPersonCircleLine)
export default ForwardRef
